import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../../utils/api';
import { useAuth } from '../../context/AuthContext';

function timeAgo(date) {
  if (!date) return 'Nunca';
  const d = (Date.now()-new Date(date))/1000/86400;
  if (d<1) return 'Hoje'; if (d<2) return 'Ontem'; return `${Math.floor(d)}d atrás`;
}

export default function MentorAlunos() {
  const { token } = useAuth();
  const [alunos, setAlunos] = useState([]);
  const [busca, setBusca] = useState('');
  const navigate = useNavigate();

  useEffect(() => { api.get('/mentor/alunos', token).then(setAlunos); }, [token]);

  const filtrados = alunos.filter(a => a.nome.toLowerCase().includes(busca.toLowerCase()) || a.email.toLowerCase().includes(busca.toLowerCase()));

  const statusInfo = (a) => {
    const d = a.ultimo_acesso ? (Date.now()-new Date(a.ultimo_acesso))/1000/86400 : 999;
    if (!a.ultimo_acesso) return ['Não acessou','badge-red'];
    if (d>14) return ['Inativo','badge-red'];
    if (d>7) return ['Parado','badge-yellow'];
    return ['Ativo','badge-green'];
  };

  return (
    <div style={{padding:'28px 32px'}}>
      <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',marginBottom:24}}>
        <div>
          <div style={{fontSize:22,fontWeight:700,letterSpacing:'-.02em'}}>Todos os Alunos</div>
          <div style={{fontSize:13,color:'#6B7289',marginTop:3}}>{alunos.length} mentorados ativos</div>
        </div>
        <button className="btn-primary" onClick={()=>navigate('/mentor/convites')}>+ Convidar aluno</button>
      </div>

      <div style={{marginBottom:16}}>
        <input className="input-field" placeholder="Buscar por nome ou email..." value={busca} onChange={e=>setBusca(e.target.value)} style={{maxWidth:360}} />
      </div>

      <div className="card" style={{padding:0,overflow:'hidden'}}>
        <table style={{width:'100%',borderCollapse:'collapse'}}>
          <thead>
            <tr style={{background:'#FAFBFE'}}>
              {['Aluno','Turma','Operações','Conquistas','Último acesso','Vencimento','Status',''].map(h=>(
                <th key={h} style={{fontSize:10,fontWeight:600,color:'#6B7289',textAlign:'left',padding:'10px 16px',textTransform:'uppercase',letterSpacing:'.06em',borderBottom:'0.5px solid #E4E6EF'}}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {filtrados.map(a=>{
              const [sl,sc]=statusInfo(a);
              return (
                <tr key={a.id} style={{borderTop:'0.5px solid #E4E6EF',cursor:'pointer'}} onClick={()=>navigate(`/mentor/alunos/${a.id}`)}
                  onMouseEnter={e=>e.currentTarget.style.background='#FAFBFE'}
                  onMouseLeave={e=>e.currentTarget.style.background='#fff'}>
                  <td style={{padding:'12px 16px'}}>
                    <div style={{fontSize:13,fontWeight:500}}>{a.nome}</div>
                    <div style={{fontSize:11,color:'#6B7289'}}>{a.email}</div>
                  </td>
                  <td style={{padding:'12px 16px'}}><span className="badge badge-blue">{a.turma||'Híbrido'}</span></td>
                  <td style={{padding:'12px 16px',fontSize:13}}>{a.operacoes}</td>
                  <td style={{padding:'12px 16px',fontSize:13}}>{a.conquistas}</td>
                  <td style={{padding:'12px 16px',fontSize:12,color:'#6B7289'}}>{timeAgo(a.ultimo_acesso)}</td>
                  <td style={{padding:'12px 16px',fontSize:11}}>
                    {a.data_vencimento ? (
                      <span style={{fontWeight:600,color:
                        new Date(a.data_vencimento) < new Date() ? '#D63B3B' :
                        new Date(a.data_vencimento) < new Date(Date.now()+30*86400000) ? '#E6A817' : '#6B7289'}}>
                        {new Date(a.data_vencimento).toLocaleDateString('pt-BR')}
                      </span>
                    ) : <span style={{color:'#9095A8'}}>—</span>}
                  </td>
                  <td style={{padding:'12px 16px'}}><span className={`badge ${sc}`}>{sl}</span></td>
                  <td style={{padding:'12px 16px'}}><button className="btn-ghost" style={{fontSize:11,padding:'5px 10px'}}>Ver perfil</button></td>
                </tr>
              );
            })}
          </tbody>
        </table>
        {filtrados.length===0 && <div style={{padding:32,textAlign:'center',color:'#6B7289',fontSize:13}}>Nenhum aluno encontrado.</div>}
      </div>
    </div>
  );
}
